import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {handlerError} from "../../../store/thunkHandlers";
import {setMessage} from "../../messages/model/slice";
import {MESSAGE_SEVERITY} from "../../../utils/const";
import {AppDispatch} from "../../../store";
import {IBoardError} from "../../board/model/actions";
import {statsAPI} from "../api";
import {IPeriod, WorkDays} from "./types";

/**
 * Thunk Статы: ошибка — всплывающим сообщением с текстом бэка (как на доске,
 * `board/model/actions.ts` `fail`), `quiet` — без него (панель по ссылке: 404 закрывает её).
 */
const statsThunk = <R, A>(type: string, run: (arg: A) => Promise<R>, quiet = false) =>
    createAsyncThunk<R, A, {dispatch: AppDispatch; rejectValue: IBoardError}>(type, async (arg, {dispatch, rejectWithValue}) => {
        try {
            return await run(arg);
        } catch (e) {
            const message = handlerError(e);
            if (!quiet) dispatch(setMessage({severity: MESSAGE_SEVERITY.error, text: message}));
            return rejectWithValue({message, status: axios.isAxiosError(e) ? e.response?.status : undefined});
        }
    });

export const fetchStatsCars = statsThunk("stats/cars", (p: IPeriod) => statsAPI.getCars(p));
export const fetchSummary = statsThunk("stats/summary", (a: {period: IPeriod; ids: string[]}) =>
    statsAPI.getSummary(a.period, a.ids),
);
export const fetchStatsCar = statsThunk("stats/car", (id: string) => statsAPI.getCar(id), true);

export const fetchSchedule = statsThunk("stats/schedule", (_: void) => statsAPI.getSchedule());
export const fetchSaveShift = statsThunk(
    "stats/saveShift",
    (a: {stage: string; work_days: WorkDays; start: string; end: string}) => {
        const {stage, ...dto} = a;
        return statsAPI.saveShift(stage, dto);
    },
);
export const fetchAddHoliday = statsThunk("stats/addHoliday", (a: {date: string; title: string}) =>
    statsAPI.addHoliday(a.date, a.title),
);
export const fetchRemoveHoliday = statsThunk("stats/removeHoliday", (id: string) => statsAPI.removeHoliday(id));
